import Enums from 'utils/EnumsManager';
import { SET_IP_LISTS, SET_IP_DETAIL, RESET_IP_DETAIL, SET_PAGINATION } from './actionType';

const { PageSize } = Enums.DefaultPageConfigs;

const initailState = {
  ipListsData: [],
  pagination: {
    total: 0,
    per_page: PageSize,
    current_page: 1,
  },
  CurrentPageData: {
    id: '',
    ip_address: '',
    // ip status has two vaule, 1 and 0, set 1 to default value
    ip_status: 1,
    comment: '',
  },
};

const ipLists = (state = initailState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_IP_LISTS:
      const { ipListsData } = payload;
      return {
        ...state,
        ipListsData,
      };

    case SET_IP_DETAIL:
      const { ipDetail } = payload;
      return {
        ...state,
        CurrentPageData: {
          ...state.CurrentPageData,
          ...ipDetail,
        },
      };

    case RESET_IP_DETAIL:
      return {
        ...state,
        CurrentPageData: initailState.CurrentPageData,
      };

    case SET_PAGINATION:
      const { paginationData } = payload;
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...paginationData,
        },
      };

    default:
      return state;
  }
};

export default ipLists;



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/flow/reducer.js